<template>
  <div class="meetingContent">
    <h4 class="boao-home-header">会议内容</h4>
    <div class="boao-home-down-icon">
      <img class="jiantou" src="./../../../assets/boao/downL.gif" alt="">
    </div>
    <div class="boao-home-title">
      <div style="font:18px/26px 'PangMenZhengDao'">ABOUT</div>
      <div class="boao-home-BBS">
        <div class="boao-home-BBS-line"></div> 
        <div class="boao-home-BBS-text"> 全球健康论坛大会</div>
      </div>
    </div>
    <div>
      <div class="meeting-referral">
        首届全球健康论坛大会将于2019年6月10日-12日在青岛西海岸新区中铁世界博览城国际会议中心举行，大会议程包括开幕式大会、政商高峰圆桌对话会、分论坛、创新项目路演会、全球健康博览会等。全球健康论坛大会将就“实现全民健康”、“创新促进健康”、“健康融入所有政策”等议题与国际同行开展交流对话。
      </div>
      <div class="meeting-presentation">大会日程还在持续更新中，请大家及时关注。</div>
      <div style="width:288px;margin: 0 auto;height: 4px;border-radius:2px;background-color: #FFC600;margin-bottom: 80px;"></div>
    </div>
    <div>
      <div class="boao-home-down-icon">
        <img class="jiantou" src="./../../../assets/boao/downL.gif" alt="">
      </div>
      <div class="boao-home-title">
        <div style="font:20px/30px 'NotoSansHans-Medium'">分论坛一</div>
        <div class="boao-home-BBS"> 
          <div class="boao-home-BBS-text">创新促进健康——互联网医疗的未来（上）</div>
        </div>
      </div>
    </div>
    <div>
      <div class="meeting-referral" style="margin-bottom: 60px;">
        随着移动互联网的不断迭代发展，特别是5G时代的到来，应用互联网等信息技术拓展医疗服务空间和内容。构建覆盖诊前、诊中、诊后的线上线下一体化医疗服务模式，新的医疗服务将发生重大的结构性变化。互联网+医辽领域技术创新，推动医疗数据的统一和互联互通，进一步助力医生协作网络，促进医疗资源的深入融合，为全球医生赋能。
      </div>
    </div>
    <div>
      <div style="font:16px/24px 'NotoSansHans-Medium';text-align: center;font-weight:900">主持人：</div>
      <div class="peopleList">
        <span class="nameLeft" style="margin-right:60px"></span>
        张  伟  四川大学华西临床医学院/华西医院党委书记
      </div>
      <div style="font:16px/24px 'NotoSansHans-Medium';text-align: center;font-weight:900;margin-top: 40px">讨论嘉宾：</div>
      <div class="peopleList">
        <span class="nameLeft"></span>
        戴 忠，中国移动通信集团政企客户分公司总经理
      </div>
      <div class="peopleList">
        <span class="nameLeft"></span>
        时占祥，全球医生组织中国总代表、NIH 临床研究中心中国项目负责人
      </div>
      <div class="peopleList">
        <span class="nameLeft"></span>
        卢清君，国家卫生健康委员会远程医疗管理与培训中心办公室主任
      </div>
      <div class="peopleList">
        <span class="nameLeft"></span>
        阴忆青，复旦大学附属中山医院信息中心主任
      </div>
      <div class="peopleList">
        <span class="nameLeft"></span>
        田懋一，世界卫生组织代表，乔治全球健康研究院（中国）高级研究员
      </div>
      <div class="peopleList">
        <span class="nameLeft"></span>
        韩宏坤，迪斯杰（北京）数据管理有限公司 董事长兼总裁
      </div>
      <div class="peopleList">
        <span class="nameLeft"></span>
        袁玉平，中卫佰医科技有限公司董事长
      </div>
      <div class="peopleList">
        <span class="nameLeft"></span>
        赵 杰，中国卫生信息学会远程医疗信息化专委会主任委员
      </div>
      <div class="peopleList">
        <span class="nameLeft"></span>  
        郑得富，江西省上饶市人民医院远程会诊中心
      </div>
    </div>
    <div style="margin-top: 80px;">
      <div class="boao-home-down-icon">
        <img class="jiantou" src="./../../../assets/boao/downL.gif" alt="">
      </div>
      <div class="boao-home-title">
        <div style="font:20px/30px 'NotoSansHans-Medium'">会议日程</div>
        <div class="boao-home-BBS"> 
          <div class="boao-home-BBS-text">「2019.06.10」</div>
        </div>
      </div>
    </div>
    <div style="margin-top:80px;">
      <div style="font:14px/24px;text-align: center">主持人: 张伟</div>
      <div style="font:14px/24px;text-align: center;margin-top: 20px;">09:00-09:05 开幕式</div>
    </div>
    <div class="scheduleDiagram">
      <div class="leftschedule">
        <div class="scheduleItem">
          <div class="leftpeopleList"></div>
          <div class="leftpeopleText">
            9:05-9:25 主旨演讲:<br />《互联网+医疗：依法执业新生态》<br />——卢清君
          </div>
        </div>
        <div class="scheduleItem">
          <div class="leftpeopleList"></div>
          <div class="leftpeopleText">
            9:45-10:05 主旨演讲：<br />《5G改变社会-互联网医疗和健康医疗大数据<br />的探索与实现》——戴忠
          </div>
        </div>
        <div class="scheduleItem">
          <div class="leftpeopleList"></div>
          <div class="leftpeopleText">
            10:20-10:35 主旨演讲：<br/>《智慧健康的未来》<br/>——田懋一
          </div>
        </div>
      </div>
      <div class="intermediateShaft">
        <div class="roundball"></div>
        <div class="dottedLine"></div>
        <div class="roundball"></div>
        <div class="dottedLine"></div>
        <div class="roundball"></div>
        <div class="dottedLine"></div>
        <div class="roundball"></div>
        <div class="dottedLine"></div>
        <div class="roundball"></div>
        <div class="dottedLine"></div>
        <div class="roundball"></div>
      </div>
      <div class="rightschedule">
        <div class="scheduleItem" style="margin-top: 64px">
          <div class="leftpeopleList"></div>
          <div class="leftpeopleText">
            9:25-9:45 主旨演讲：<br/>《5G与智慧医疗》——赵杰
          </div>
        </div>
        <div class="scheduleItem">
          <div class="leftpeopleList"></div>
          <div class="leftpeopleText">
            10:05-10:20 主旨演讲：<br/>《探讨互联网+医疗健康：<br/>是先加医疗，还比先加健康？》<br/>——时占祥
          </div>
        </div>
        <div class="scheduleItem">
          <div class="leftpeopleList"></div>
          <div class="leftpeopleText">
            10:35-10:45 茶歇
          </div>
        </div>
      </div>
    </div>
    <div style="margin-top:20px;">
      <div style="font:14px/24px;text-align: center">主持人: 赵杰</div>
    </div>
    <div class="scheduleDiagram">
      <div class="leftschedule">
        <div class="scheduleItem">
          <div class="leftpeopleList"></div>
          <div class="leftpeopleText">
            10:45-11:05 主旨演讲<br/>《信息化时代的未来医疗发展趋势》<br/>——张  伟
          </div>
        </div>
        <div class="scheduleItem">
          <div class="leftpeopleList"></div>
          <div class="leftpeopleText">
            11:20-11:35 主旨演讲<br/>《地方市级医院基于远程医疗的医联体建设经验》<br/>——郑德富
          </div>
        </div>
        <div class="scheduleItem">
          <div class="leftpeopleList"></div>
          <div class="leftpeopleText">
            11:50-12:05 主旨演讲 <br/>《数据、数据治理与医学大脑的未来》<br/>——韩宏坤
          </div>
        </div>
      </div>
      <div class="intermediateShaft">
        <div class="roundball"></div>
        <div class="dottedLine"></div>
        <div class="roundball"></div>
        <div class="dottedLine"></div>
        <div class="roundball"></div>
        <div class="dottedLine"></div>
        <div class="roundball"></div>
        <div class="dottedLine"></div>
        <div class="roundball"></div>
        <div class="dottedLine"></div>
        <div class="roundball"></div>
      </div>
      <div class="rightschedule">
        <div class="scheduleItem" style="margin-top: 64px">
          <div class="leftpeopleList"></div>
          <div class="leftpeopleText">
            11:05-11:20 主旨演讲<br/>《互联网医院时代的医院信息化建设》<br/>——阴忆青
          </div>
        </div>
        <div class="scheduleItem">
          <div class="leftpeopleList"></div>
          <div class="leftpeopleText">
            11:35-11:50 主旨演讲<br/>《关于远程医疗建设和运营的探索》<br/>——袁玉平
          </div>
        </div>
        <div class="scheduleItem">
          <div class="leftpeopleList"></div>
          <div class="leftpeopleText">
            12:05 午餐
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  
}
</script>

<style lang="less" scoped>
.meetingContent{
  width: 1000px;
  margin: 0 auto;
}
.boao-home-page{
  width: 1000px;
  margin: 0 auto;
}
.boao-home-header{
  text-align: center;
  color: #333;
  font: 24px/30px 'NotoSansHans-Medium';
}
.boao-home-down-icon{
  margin: 20px auto;
  width: 32px;
}
.boao-home-title{
  text-align: center;
}
.boao-home-BBS{
  margin-top:5px;
  text-align: center;
  .boao-home-BBS-line{
    width: 36px;
    height:12px;
    display: inline-block;
    border-bottom: 4px solid #FFC600;
    vertical-align: top;
  }
  .boao-home-BBS-text{
    vertical-align: top;
    font: 20px/20px 'NotoSansHans-Bold';
    color: #333;
    display: inline-block;
  }
}
.meeting-referral{
  margin:40px auto 30px;
  width: 660px;
  font: 14px/24px 'NotoSansHans-Regular';
  color: #333;
}
.meeting-presentation{
  margin:0 auto;
  width: 660px;
  text-align: center;
  font: 14px/46px 'NotoSansHans-Regular';
  color: #999999;
}
.peopleList{
  width: 660px;
  margin: 20px auto 0;
  padding-left: 70px;
  font:16px/24px 'NotoSansHans-Regular';
}
.nameLeft{
  width:12px;
  height:14px;
  background-image: url('./../../../assets/Pc/triangleyellow.png');
  background-size: 12px 14px;
  display:inline-block;
  margin-right:22px;
}
.scheduleDiagram{
  width: 800px;
  margin: 20px auto;
  .leftschedule{
    display: inline-block;
    vertical-align: top;
    width: 380px;
    
  }
  .scheduleItem{
      height: 128px;
    }
  .intermediateShaft{
    vertical-align: top;
    display: inline-block;
    width: 30px;
    padding:0 7px;
    .roundball{
      width: 16px;
      height: 16px;
      border-radius: 50%;
      background-color: #198BFF;
    }
    .dottedLine{
      width: 9px;
      height: 48px;
      border-right: 2px dashed #198BFF;
    }
  }
  .rightschedule{
    vertical-align: top;
    display: inline-block;
    height:20px;
    width: 380px;
    padding-left: 100px;
  }
  .leftpeopleList{
    display:inline-block;
    width:12px;
    height:14px;
    vertical-align: top;
    background-image: url('./../../../assets/Pc/triangleyellow.png');
    background-size: 12px 14px;
    margin-right:22px;
  }
  .leftpeopleText{
    display:inline-block;
    font: 14px/24px 'NotoSansHans-Regular';
  }
}
</style>
